import {Component, Input} from "@angular/core";
import {StatusIndicatorState} from "./status-indicator-state";

@Component({
  selector: "status-indicator",
  templateUrl: "./status-indicator.template.pug",
})
export class StatusIndicatorComponent {
  key: string;
  text: string;
  color: string;
  icon: string; // todo - this ain't right
  states: StatusIndicatorState[] = [];

  @Input("states")
  set statesProp(states: StatusIndicatorState[]) {
    this.states = states;
    this.updateDisplay();
  }

  get statesProp(): StatusIndicatorState[] {
    return this.states;
  }

  @Input("key")
  set keyProp(key: string) {
    this.key = key;
    this.updateDisplay();
  }

  get keyProp(): string {
    return this.key;
  }

  @Input("detail")
  detail: string;

  updateDisplay() {
    const key = this.key;
    const state = this.states.find(it => it.key === key);

    if (state) {
      this.text = state.text || "";
      this.color = state.color || "";
      this.icon = state.icon || "";
    } else {
      this.text = "";
      this.color = "";
      this.icon = "";
    }
  }
}
